var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--partner-with-us_contents new-container mx-auto"
  }, [_c('div', {
    staticClass: "partner-with-us-contents d-grid grid-cols-lg-12 gap-20 gap-sm-30 gap-lg-40"
  }, _vm._l(_vm.contents, function (content, index) {
    return _c('div', {
      key: `partner-with-us-content-item-${index}`,
      staticClass: "partner-with-us-content-item col-span-lg-10 col-start-lg-2 d-grid grid-cols-1 grid-cols-lg-10 gap-30"
    }, [_c('div', {
      class: ['partner-with-us-content-item-text col-span-lg-4', {
        'col-start-lg-7 reverse-layout': content.reverse
      }]
    }, [_c('h2', [_vm._v(_vm._s(content.title))]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(content.content)
      }
    })]), _vm._v(" "), _c('div', {
      class: ['partner-with-us-content-item-image col-span-lg-5', {
        'col-start-lg-6': !content.reverse,
        'col-start-lg-1 reverse-layout': content.reverse
      }]
    }, [_c('nuxt-img', {
      attrs: {
        "src": content.img,
        "alt": content.title,
        "width": "445",
        "height": "455",
        "loading": "lazy"
      }
    })], 1)]);
  }), 0)]);

}
var staticRenderFns = []

export { render, staticRenderFns }